module.exports = __webpack_public_path__ + "assets/img/8.f50aa91a.png";